import React, { useEffect, useState } from "react";
import { Button, Input, Row } from "antd";
import { _get, _post } from "../../Utils/Helper";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { acadamicTerms, academicYear } from "../../../core/common/selectoption/selectoption";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

interface Payment {
  amount: string,
  term: string,
  academic_year: string,
  admission_no: string;
  school_id: string;
  item_code: string;
  description: string;
  status: string;
  code: string;
  is_optional: string;
  student_type: string;
  discount: string,
  fines: string;
  checked: boolean;
}

// Define the props type for the component
interface StudentModalsProps {
  admission_no: string;
  admission_no1:string, // Type of admission_no (you can change it if it's not a number)
  class_name:string;
  academic_year:string;
  term:string;
}

const StudentCopyBillModal: React.FC<StudentModalsProps> = (props) => {
  const { admission_no1, admission_no, class_name, academic_year, term} = props;
//   const StudentData = {
//     id: 0,
//     age: 0,
//     section: '',
//     student_name: '',
//     email: '',
//     phone: '',
//     address: '',
//     admission_no: '',
//     current_class: "",
//     state_of_origin: '',
//     l_g_a: '',
//     last_school_attended: '',
//     school_id: 0
//   }
  const _form = {
    query_type: "create",
    id: "",
    item_code: "",
    description: "",
    amount: 0,
    qty: "1",
    academic_year: academicYear[0].value,
    term: acadamicTerms[0].value,
    discount: "",
    due_date: "",
    class_name: "",
    created_by: "",
    fines: "",
  }
  // Initialize the student state with the Student type
//   const [student, setStudent] = useState<Student>(StudentData);
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth)
  const [form, setForm] = useState(_form)
  
  const [selectedRows, setSelectedRows] = useState<Payment[]>(payments.filter((payment: Payment) => payment.checked));

  const total = selectedRows.reduce((acc, payment:Payment) => {
    return acc + parseFloat(payment.amount);
  }, 0);

  const handleAddAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedRows(payments.map((payment: Payment) => ({ ...payment, checked: true })));
    } else {
      setSelectedRows(payments.filter((payment: Payment) => (payment.is_optional === 'No'))); // Clear all selections when "Select All" is unchecked
    }
  };

  // Handle individual row selection
  const handleAddList = (e: React.ChangeEvent<HTMLInputElement>, payment: Payment) => {
    if (e.target.checked) {
      setSelectedRows((prev) => {
        if (!prev.some((item) => item.code === payment.code)) {
          return [...prev, { ...payment, checked: true }];
        }
        return prev;
      });
    } else {
      setSelectedRows((prev) => prev.filter((item) => item.code !== payment.code));
    }
  };
  // Check if "Select All" checkbox should be checked
  const isAllSelected = payments.length > 0 && selectedRows.length === payments.length;

  const handleChangeForm=(e:React.ChangeEvent<HTMLInputElement>,)=>{
    const { name, value } = e.target;
    setForm((p)=>({...p, [name]:value}))
  }
  useEffect(() => {
    if (admission_no1) {
        setLoading(true);
        _post(
            "payments",
            {
                query_type: "select",
                admission_no:admission_no1,
                term,
                academic_year
            },
            (resp) => {
                if (resp.success && resp.data.length) {
                    const paymentData = resp.data.map((x: Payment) => ({
                        ...x,
                        checked: true,
                    }));
                    setForm((p)=>({...p, due_date:resp.data[0].due_date}))
                    setPayments(paymentData);
                    setSelectedRows(paymentData.map((p: any) =>({...p,checked:true})));
                }
                setLoading(false);
            },
            (err) => {
                console.error(err);
                setLoading(false);
            }
        );
    }
}, [admission_no1, term, academic_year]);
//   useEffect(() => {

//     setLoading(true);
//     _get(
//       `students?query_type=select&admission_no=${admission_no}`,
//       (res: { data: Student[] }) => {
//         if (res.data && res.data.length > 0) {
//           setStudent(res.data[0]);
//           setForm((p) => ({
//             ...p,
//             admission_no: res.data[0].admission_no,
//             student_name: res.data[0].student_name,
//             class_name: res.data[0].current_class
//           }))
//           setLoading(false);
//         }
//       },
//       (err: any) => {
//         console.error(err);
//         setLoading(false);
//       }
//     );
//   }, [admission_no]);

// 
// 

  // const handleSubmit = () => {
  //   setLoading(true);
  //   const data = selectedRows.map(x => ({
  //     description: x.description,
  //     amount: x.amount,
  //     qty: 1,
  //     academic_year,
  //     due_date: moment().format('YYYY-MM-DD'),
  //     created_by: user.name,
  //     item_code: x.code,
  //     discount:x.discount,
  //     fines:x.fines,
  //     term,
  //     class_name,
  //     query_type: 'create'
  //   }))
  //   if(data.length>0){
  //     data.push({
  //       description: `Bill Summary: ${data[0].description}  ${data.length>2?`& (${data.length-2})`:data.length>=1?'& (1)':''}) ${data.length>=1?"Other":""} ${data.length>=2?'Items':data.length>=1?"Item":""}`,
  //       amount: '0',
  //       qty: 1,
  //       class_name,
  //       academic_year,
  //       due_date: form.due_date,
  //       created_by: user.name,
  //       discount: form.discount||"0",
  //       fines: form.fines||"0",
  //       item_code: data[0]?.item_code,
  //       term: form.term,
  //       query_type: 'create'
  //     })
  //   }
  //  const list = admission_no?.split(',')
  //  list?.forEach((std:any,idx:number)=>{
  //   _post(
  //     `payments`,
  //     data.map(x=>({...x,admission_no:std})),
  //     (resp) => {
  //       if (resp.success) {
  //         console.log(resp)
  //         // setPayments(resp.data.map((payment: Payment) => ({ 
  //         //   ...payment, 
  //         //   fines: 0, discount: 0, 
  //         //   checked: payment.is_optional === 'No' 
  //         // })));
  //         // setSelectedRows(resp.data.filter((payment: Payment) => (payment.is_optional === 'No')).map((x: Payment) => ({ ...x, checked: true, fines: 0, discount: 0,  })))
  //         // setLoading(false)
  //         toast.success("Submitted")
  //       }
  //     },
  //     (err) => {
  //       toast.error("Failed")
  //       console.error(err);
  //       // setLoading(false);
  //     }
  //   );
  //  })
  // };
  const handleSubmit = async () => {
    setLoading(true);
  
    // Prepare the data
    const baseData = selectedRows.map((x) => ({
      description: x.description,
      amount: x.amount,
      item_code:x.item_code,
      qty: 1,
      academic_year,
      due_date: moment().format("YYYY-MM-DD"),
      created_by: user.name,
      discount: x.discount,
      fines: x.fines,
      term,
      class_name,
      query_type: "create",
    }));
  
    // Add summary row if necessary
    // if (baseData.length > 0) {
    //   baseData.push({
    //     description: `Bill Summary: ${baseData[0].description} ${
    //       baseData.length > 2
    //         ? `& (${baseData.length - 2})`
    //         : baseData.length >= 1
    //         ? "& (1)"
    //         : ""
    //     } ${
    //       baseData.length >= 1 ? "Other" : ""
    //     } ${baseData.length >= 2 ? "Items" : baseData.length >= 1 ? "Item" : ""}`,
    //     amount: "0",
    //     qty: 1,
    //     class_name,
    //     academic_year,
    //     due_date: form.due_date,
    //     created_by: user.name,
    //     discount: form.discount || "0",
    //     fines: form.fines || "0",
    //     item_code: baseData[0]?.item_code,
    //     term: form.term,
    //     query_type: "create",
    //   });
    // }
  
    // Split admission numbers into an array
    const admissionNumbers = admission_no.split(",");
  
    // Prepare requests
    const requests = admissionNumbers.map((admissionNumber) => {
      const payload = baseData.map((x) => ({ ...x, admission_no: admissionNumber }));
      return _post(`payments`, payload);
    });
  
    try {
      // Execute all requests concurrently
      const responses = await Promise.allSettled(requests);
  
      // Handle success and errors
      const successfulResponses = responses.filter(
        (response:any) => response.success
      );
      const failedResponses = responses.filter((response) => response.status === "rejected");
  
      if (successfulResponses.length > 0) {
        toast.success(`${successfulResponses.length} submissions successful.`);
        console.log("Successful submissions:", successfulResponses);
      }
  
      if (failedResponses.length > 0) {
        toast.error(`${failedResponses.length} submissions failed.`);
        console.error("Failed submissions:", failedResponses);
      }
    } catch (error) {
      toast.error("An unexpected error occurred.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div
      className="modal fade"
      id="copy_fees_collect"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
            <h4 className="mb-3">
              <table>
                <tr>
              <td className="">{class_name || ""}</td> <td><Input type="text" value={admission_no} /></td>
           </tr> 
           </table>
           </h4>
          </div>
          <div className="card">
            {/* {JSON.stringify(student)}x1 */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
               
                {/* <div className="row">
                <div className="col-md-6">

                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <AcademicYearSelect
                      onChange={(year) => {
                        setForm((p) => ({ ...p, academic_year: year }))
                      }}
                      selectedYear={form.academic_year}
                    />
                  </div>
                </div> 

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Term</label>
                    <CommonSelect
                      className="select"
                      options={acadamicTerms}
                      defaultValue={{
                        label: form.term,
                        value: form.term,
                      }}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          term: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>
                </div>
              </div> */}
            </div>
            <div className="card-body p-0 py-3">
              {/* Fees List */}
              <div className="custom-datatable-filter table-responsive">
                <table className="table datatable table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th>
                        <Input
                          name="admission_no"
                          checked={isAllSelected}
                          onChange={handleAddAll}
                          type="checkbox" />
                      </th>
                      <th>Description</th>
                      <th>Student Type</th>
                      <th>Amount (NGN)</th>
                    </tr>
                  </thead>
                  {payments.length && !loading ? <tbody>
                    {payments.filter((x:Payment)=>parseFloat(x.amount)>0).map((payment: Payment, index: number) => (
                      <tr key={index}>
                        <td>
                          <Input
                            name="admission_no"
                            checked={selectedRows.some((item) => item.code === payment.code)}
                            onChange={(e) => handleAddList(e, payment)}
                            type="checkbox"
                          />
                        </td>
                        <td>
                          <p className="text-primary fees-group">
                            <span className="d-block">{payment.description}</span>
                          </p>
                        </td>
                        <td>
                          <span className="badge badge-soft-success d-inline-flex align-items-center">
                            <i className="ti ti-circle-filled fs-5 me-1" />
                            {payment.student_type}
                          </span>
                        </td>
                        <td>{payment.amount}</td>
                       
                        {/* <td><Input name="discount" onChange={(e) => handleChange(e, payment)} value={payment.discount} placeholder="Discount" type="number" /></td>
                        <td><Input name="fines" onChange={(e) => handleChange(e, payment)} value={payment.fines} type="number" /></td> */}
                      </tr>
                    ))}
                  </tbody> : loading ?
                    <Spinner /> :
                    <h3 className="text-warning text-center">N/A</h3>}
                </table>
              </div>
              {/* {JSON.stringify(selectedRows)} */}
              <Row>
                <div className="col-md-6 p-3 m-3 offset-2">
                  <div className="form-group m-3">
                    <label>Total Fines</label>
                    <Input name="fines"  onChange={handleChangeForm}  placeholder="" value={form.fines} type="number" />
                  </div>

                  <div className="form-group m-3">
                    <label> Discount</label>
                    <Input 
                      name="discount" 
                      onChange={handleChangeForm}  
                      value={form.discount} placeholder="Total Discount" 
                      type="number" 
                      />
                  </div>

                  <div className="form-group m-3">
                    <label>Total Payable</label>

                    <Input 
                      placeholder="Total Invoice" 
                      value={total} 
                      type="text" 
                    />
                  </div>
                  <div className="form-group m-3">
                    <label>Due Date</label>
                    <Input name="due_date" onChange={handleChangeForm} placeholder="Due Date" value={form.due_date} type="date" />
                  </div>
                </div>

              </Row>
              {/* /Fees List */}
            </div>
            <div className="card-footer">
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 5,
                }}
              >

                <Button
                  color="primary"
                  className="btn btn-primary p-2"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentCopyBillModal;
